import { useState } from "react";
import { motion } from "framer-motion";

const LEVELS = [
  { max: 3, label: "Solco sano", color: "#86C89B", text: "Tra 1 e 3 mm la gengiva aderisce bene al dente e il sondaggio di solito non fa sanguinare. Basta un'igiene accurata e i controlli periodici." },
  { max: 5, label: "Tasca iniziale o moderata", color: "#D9B86A", text: "Tra 4 e 5 mm i batteri hanno iniziato a scavare sotto la gengiva. È il momento ideale per intervenire: con il laser si recupera molto spesso senza chirurgia." },
  { max: 9, label: "Tasca profonda", color: "#C9826F", text: "Da 6 mm in su l'osso di sostegno è già coinvolto e il dente può iniziare a muoversi. La terapia laser decontamina in profondità e aiuta a salvare i denti naturali." },
];

const levelOf = (mm) => LEVELS.find((l) => mm <= l.max);

const Probe = ({ mm, color }) => (
  <div className="relative w-24 h-72 mx-auto" aria-hidden="true">
    <div className="absolute inset-x-5 top-0 bottom-0 rounded-t-[40%] rounded-b-2xl bg-[#FCFBF7] border border-[#D5DFD3]" />
    <div className="absolute inset-x-0 top-10 h-8 rounded-full bg-[#E3C7BF]/70" />
    <motion.div className="absolute left-1/2 -translate-x-1/2 top-10 w-2.5 rounded-b-full" style={{ backgroundColor: color }} animate={{ height: mm * 22 }} transition={{ type: "spring", stiffness: 120, damping: 18 }} />
    {Array.from({ length: 9 }, (_, i) => (
      <span key={i} className="absolute right-0 f-mono text-[9px] text-[#526356]" style={{ top: 40 + (i + 1) * 22 - 6 }}>{i + 1}</span>
    ))}
  </div>
);

export const PocketGauge = () => {
  const [mm, setMm] = useState(4);
  const lvl = levelOf(mm);
  return (
    <div className="rounded-[2rem] bg-[#FCFBF7] border border-[#D5DFD3] p-6 sm:p-10 grid md:grid-cols-[auto_1fr] gap-8 items-center" data-testid="pocket-gauge">
      <Probe mm={mm} color={lvl.color} />
      <div>
        <p className="eyebrow text-[#3E6B48]">Prova tu</p>
        <p className="f-serif text-6xl text-[#1B3B28] mt-2" data-testid="pocket-gauge-value">{mm} mm</p>
        <input type="range" min={1} max={9} value={mm} onChange={(e) => setMm(Number(e.target.value))} className="w-full mt-4 accent-[#3E6B48]" aria-label="Profondità della tasca in millimetri" data-testid="pocket-gauge-slider" />
        <div className="flex justify-between f-mono text-xs text-[#526356] mt-1"><span>1 mm</span><span>9 mm</span></div>
        <motion.div key={lvl.label} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} className="mt-6">
          <span className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-sm text-[#1B3B28]" style={{ backgroundColor: `${lvl.color}33` }} data-testid="pocket-gauge-label">
            <span className="w-2 h-2 rounded-full" style={{ backgroundColor: lvl.color }} /> {lvl.label}
          </span>
          <p className="text-[#526356] mt-3 leading-relaxed" data-testid="pocket-gauge-text">{lvl.text}</p>
        </motion.div>
      </div>
    </div>
  );
};
